<template>
  <v-dialog max-width="500px" persistent v-model="show">
    <v-card tile>
      <v-card-title>
        <v-toolbar-title>Update Password</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="update">OK</v-btn>
        <v-btn @click="turnBack">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <div v-if="'MORE_THAN_THREE_MONTHS' === type">
                パスワードの有効期限が切れています。パスワードを変更してください。
              </div>
              <div required>
                <v-text-field
                  :rules="[
                    (v) => !!v || `New Password is required`,
                    (v) =>
                      /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%+=_\-^&*?]).*$/.test(
                        v
                      ) ||
                      `パスワードの書式  最小8桁、最大16桁まで、少なくとも一つの大文字、小文字、数字と特殊記号を含む必要があります。`,
                    (v) =>
                      /^[^\s]*$/.test(v) ||
                      'パスワードにはスペースが入ってはいけません。',
                  ]"
                  label="New Password"
                  type="password"
                  v-model="newPassword"
                />
              </div>
            </v-flex>
            <v-flex xs12>
              <div required>
                <v-text-field
                  :rules="[
                    (v) => !!v || `Password Again is required`,
                    (v) => v == this.newPassword || `Password must match`,
                  ]"
                  label="Password Again"
                  type="password"
                  v-model="againPassword"
                />
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import md5 from 'md5'
import { mapGetters } from 'vuex'
import { Encrypt } from '../service/Encrypt'

export default {
  props: ['type'],
  data() {
    return {
      show: false,
      valid: false,
      newPassword: null,
      againPassword: null,
      force: null,
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    turnBack() {
      this.show = false
      if (this.force) {
        return this.$http
          .get(
            '/employees/clear-login?userAccountId=' +
              this.$store.getters.user.userAccountId
          )
          .then(() => {
            this.logoff()
          })
      }
    },
    popup(force) {
      this.force = force
      this.show = true
    },
    update() {
      return this.$http
        .put(`/auth-service/auth/admin-update-password`, {
          userId: this.$store.getters.user.userAccountId,
          newPassword: Encrypt(this.newPassword),
        })
        .then((res) => {
          console.log(res)
          if (res.data.success) {
            return this.$http
              .get(
                '/employees/change-date?userAccountId=' +
                  this.$store.getters.user.userAccountId,
                {
                  headers: {
                    jumpAuth: true,
                  },
                }
              )
              .then(() => {
                this.show = false
                this.logoff()
              })
          } else {
            this.$showApiError(res)
          }
        })
        .catch(() => {
          this.$message('', 'パスワードのリセットに失敗しました', 'ERROR')
        })
    },
    logoff() {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('user')
      localStorage.removeItem('currentEmployee')
      this.$store.dispatch('LOGOUT')
      this.$router.push('B0100')
    },
  },
}
</script>
